import { makeStyles } from '@material-ui/core'
import { ArrowForward, Autorenew, Close } from '@material-ui/icons'
import React, { useState, useReducer, useEffect } from 'react'
import {
  useMutation,
  useNotify,
  useRecordContext,
  useRefresh,
  useShowContext,
} from 'react-admin'
import Button from '../../../common/customized-mui-components/Button'
import { useHasAuthority } from '../../../hooks/useHasAuthority'
import { Authority } from '../../../../core/auth/Authority'
import { ToggleType } from '../../../../core/devices/barriers/barrier-set-boolean-status-button'
import { BarrierSelectStateDialog } from '../BarrierDialogs'
import { BarrierDto } from '../../../../core/dto/device/barrier/barrier.dto'
import {
  barrierSetFreePassButtonInitialState,
  barrierSetFreePassButtonReducer,
} from '../../../../core/devices/barriers/barrier-set-free-pass-button.reducer'

const useStyles = makeStyles({
  icon: {
    position: 'absolute',
    left: 5,
    top: 5,
    fontSize: '24px !important',
  },
  crossIcon: {
    position: 'absolute',
    left: 0,
    top: 0,
    fontSize: 34,
  },
})

export const BarrierSetFreePassButton = ({ ...props }) => {
  const { asRecurringJob, disabled, ...rest } = props
  const notify = useNotify()
  const hasAuthority = useHasAuthority()
  const { loading } = useShowContext()
  const classes = useStyles()

  const [{ mutateQuery }, dispatch] = useReducer(
    barrierSetFreePassButtonReducer,
    barrierSetFreePassButtonInitialState,
  )
  const [dialogOpen, setDialogOpen] = useState(false)
  const [state, setState] = useState(false)
  const barrier = useRecordContext<BarrierDto>()
  const [mutate, { loading: mutationLoading }] = useMutation()
  const refresh = useRefresh()

  useEffect(() => {
    if (state) {
      dispatch({ type: ToggleType.OFF })
    } else {
      dispatch({ type: ToggleType.ON })
    }
  }, [state])

  const handleFreePass = async (
    recurringJobName?: string,
    cronExpression?: string,
    auditNote?: string,
  ) => {
    let query
    if (!asRecurringJob) {
      query = mutateQuery?.(barrier, auditNote)
    } else {
      query = mutateQuery?.(
        barrier,
        auditNote,
        recurringJobName as string,
        cronExpression as string,
      )
    }
    await mutate(query, {
      returnPromise: true,
      onFailure: (err) => notify(err?.message, 'error'),
    })
    refresh()
  }

  return (
    <>
      <BarrierSelectStateDialog
        open={dialogOpen}
        confirm={handleFreePass}
        method="freePass"
        close={() => setDialogOpen(false)}
        state={state}
        setState={setState}
        asRecurringJob={asRecurringJob}
        OnIcon={<ArrowForward className={classes.icon} />}
        OffIcon={
          <>
            <ArrowForward className={classes.icon} />
            <Close fontSize="large" className={classes.crossIcon} />
          </>
        }
        withAuditNote
      />
      <Button
        disabled={
          !hasAuthority(Authority.BARRIERS_SET_FREE_PASS_BUTTON) ||
          loading ||
          mutationLoading ||
          disabled === true
        }
        variant="contained"
        color="primary"
        onClick={() => setDialogOpen(true)}
        label={
          !asRecurringJob
            ? 'resources.barriers.actions.setFreePassState.set'
            : ''
        }
        useSmallVersionBreakpoint={false}
        {...rest}
      >
        {asRecurringJob ? <Autorenew /> : undefined}
      </Button>
    </>
  )
}
